const schema = localStorage.getItem("schema")
const currentDate = new Date()
export const basicFormData = () => ({
  inputData: {
    job_card_no: "",
    technician_id: "",
    assigned_by: "",
    technician_check_at: currentDate.toString(),
    technician_check_is_repairable:false,
    technician_check_remark:"",
    scrap_remark:"",
    created_by: "",
    updated_by: "",
    is_active: true,
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "job_cards",
    schema:schema,
    "include": [
      {
        "model": "user_masters",
        "as": "technician"
      },
      {
        "model": "user_masters",
        "as": "assigned_by_user"
      },
      {
        "model": "material_intakes",
        "as": "intake"
      }
    ],
    "relation": [
      { "model": "material_intakes", "as": "intake" },
      { "model": "user_masters", "as": "technician" },
      { "model": "user_masters", "as": "assigned_by_user" },
      { "model": "spare_part_requests", "as": "spare_requests" }
    ]
  };

  const navigatePage = { back: "/job-card-list" };

  const headerName = "Job Card";

  const validationType = "JobCardCreate";
  const createEndpoint = "/updaterelationaldata  ";
  const updateEndpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";
  
  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};


export const listPageData = () => {
  const payload = {
    modelName: "job_cards",
    schema:schema,
    "include": [
      {
        "model": "user_masters",
        "as": "technician"
      },
      {
        "model": "user_masters",
        "as": "assigned_by_user"
      },
      {
        "model": "material_intakes",
        "as": "intake"
      }
    ],
    "relation": [
      { "model": "material_intakes", "as": "intake" },
      { "model": "user_masters", "as": "technician" },
      { "model": "user_masters", "as": "assigned_by_user" },
      { "model": "spare_part_requests", "as": "spare_requests" }
    ]
    // relations: [
    //   {
    //     module: "user_masters",
    //     moduleAs: "createdBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    // ],
  };

  const columnData = [
    { label: "Sr.no", value: "index" },
    { label: "Job Card No", value: "job_card_no" },
    { label: "Intake No", value: "intake.intake_no" },
    { label: "Technician", value: "technician_full_name" },
    { label: "Assigned By", value: "assigned_by_full_name" },
    { label: "Technician Check", value: "technician_check_at" },
    { label: "Technician Check Is Repairable", value: "technician_check_is_repairable" },
    { label: "Technician Check Remark", value: "technician_check_remark" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/job-card-create",
    edit: "/job-card-create",
    view: "/job-card-view",
  };

  const searchfields = [
    "branch_name",
    "country_name",
    "state_name",
    "city_name",
  ];

  const headerName = "Job Card";
  const endpoint = "/getRecords";
  const exportFileName = "JobCardData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};

export const exportPageData = {
  modelName: "job_cards",
  schema: schema,
  "include": [
    {
      "model": "user_masters",
      "as": "technician"
    },
    {
      "model": "user_masters",
      "as": "assigned_by_user"
    }
  ],
  "relation": [
    { "model": "material_intakes", "as": "intake" },
    { "model": "user_masters", "as": "technician" },
    { "model": "user_masters", "as": "assigned_by_user" },
    { "model": "spare_part_requests", "as": "spare_requests" }
  ],
  pagination: { page: 1, pageSize: 10000 },
};
